/** @file slotKeyOfFile: the slot key a file name or zip path stands for (dot, dash or slash). */

const NAME = /^(.+)[./-](\d+)[./-](\d+)$/;

/**
 * `face.0.4.png`, `face-0-4.png`, `face/0/4.png` (any folder in front) give `face/0/4` when that slot is in `known`;
 * a drawable id may itself hold dots (`att0.sword.0.0.png`). Null when no slot matches.
 */
export function slotKeyOfFile(name: string, known: ReadonlySet<string>): string | null {
  const path = name.replaceAll('\\', '/').replace(/\.png$/i, '');
  const parts = path.split('/');
  for (let i = 0; i < parts.length; i += 1) {
    const m = NAME.exec(parts.slice(i).join('/'));
    if (m === null) continue;
    const key = `${m[1] ?? ''}/${String(Number(m[2]))}/${String(Number(m[3]))}`;
    if (known.has(key)) return key;
  }
  return null;
}
